"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlIframeComponent = void 0;
const core_1 = require("@angular/core");
let HtmlIframeComponent = class HtmlIframeComponent {
    onIframeLoad(iframe) {
        var _a;
        const doc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
        if (doc) {
            const style = doc.createElement('style');
            style.innerHTML = `
        body {
          font-family: 'Arial', sans-serif;
        }
      `;
            doc.head.appendChild(style);
        }
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], HtmlIframeComponent.prototype, "iframeContent", void 0);
HtmlIframeComponent = __decorate([
    (0, core_1.Component)({
        selector: 'html-iframe',
        template: '<div class="boxL"><iframe #myIframe class="html-iframe" [srcdoc]="iframeContent" (load)="onIframeLoad(myIframe)"></iframe></div>',
    })
], HtmlIframeComponent);
exports.HtmlIframeComponent = HtmlIframeComponent;
